// IIFE implementation
(function () {
  /**
   * This class is added to adjust the location of search icon on the menu bar.
   * Currently this code is added from VWO.
   */
  // document.body.classList.add('docs-search-auth-user');

  var docSearchInputBox = getQuerySelector('#doc-search-box input'),
    docSearchMenuIcon = document.querySelectorAll('.doc-search-menu-icon'),
    docSearchContainerOverlay = getQuerySelector('#doc-search-overlay'),
    body = getQuerySelector('html'),
    docResetButton = getQuerySelector('.ds__input__handle--reset'),
    searchContainer = getQuerySelector('#doc-search-container'),
    docInputHandle = getQuerySelector('#ds-input-handle'),
    docSearchInputContainer = getByClassName('ds__input__container'),
    docTopBar = getQuerySelector('.ds__container .ds__top-bar'),
    docSubmitButton = getQuerySelector('.ds__input__handle--submit'),
    docCloseIcon = getQuerySelector('.ds--close'),
    globalSearchFlag = true,
    localSearchFlag = true;

  function getQuerySelector(id) {
    return document.querySelector(id);
  }
  function getByClassName(className) {
    return document.getElementsByClassName(className);
  }
  // Events to hide and show search container
  if (docSearchMenuIcon && docSearchContainerOverlay && docCloseIcon) {
    docSearchMenuIcon.forEach(function (node) {
      node.addEventListener('click', function (e) {
        e.preventDefault();
        searchContainer.classList.add('show-doc');
        body.classList.add('doc-search-enabled');
        docSearchInputBox.focus();
        WebEventTracker.logEvent(EDS.webEvents, 'ClickonGlobalSearchIcon', {});
      });
    });
    init();
  }
  function init() {
    // Input Box OnKeyUp Event to hide and show Dropdown
    if (docSearchInputBox) {
      docSearchInputBox.addEventListener('keyup', function (e) {
        if (!e.target.value) {
          docInputHandle.classList.add('hide');
        } else if (window.innerWidth > 979) {
          docInputHandle.classList.remove('hide');
          lazyLoading.show();
        }
      });
      docSearchInputBox.addEventListener('focus', function () {
        docSearchInputContainer[0].classList.add('input-box-focused');
        if (docSubmitButton.classList.contains('hide')) {
          docSubmitButton.classList.remove('hide');
        }
      });
      docSearchInputBox.addEventListener('focusout', function (e) {
        docSearchInputContainer[0].classList.remove('input-box-focused');
      });
      if (docResetButton) {
        docResetButton.addEventListener('click', function () {
          docInputHandle.classList.add('hide');
          docSearchInputBox.focus();
        });
      }
    }
    
    // Function to close search box and initialize values
    function resetDocSearchToInitialState() {
      searchContainer.classList.remove('show-doc');
      body.classList.remove('doc-search-enabled');
      docInputHandle.classList.add('hide');
      docSearchInputBox.value = '';
    }
    docSearchContainerOverlay.addEventListener('click', function () {
      resetDocSearchToInitialState();
    });
    docCloseIcon.addEventListener('click', function () {
      resetDocSearchToInitialState();
    });
    //  events to make dropdown list navigate and redirect using keyboard buttons
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        resetDocSearchToInitialState();
      }
    });
    // event for default state
    docTopBar.addEventListener('click', function (event) {
      var classListNode = event.target.classList;
      if (classListNode.contains('container') || classListNode.contains('ds__top-bar')) {
        docSearchInputContainer[0].classList.remove('input-box-focused');
        docSubmitButton.classList.add('hide');
      }
    });

    function reportWindowSize() {
      if (window.innerWidth < 979) {
        docInputHandle.classList.add('hide');
      } else {
        docInputHandle.classList.remove('hide');
      }
    }
    // window resize
    window.onresize = reportWindowSize;

    /** Enable Search for everyone.
     * Except ie and Ipad two and three.
     * Except of enterprise customer and algolia js is blocked for him.
     */
    function showHideSearchIcon(param) {
      var searchMenuIcon = document.querySelectorAll('.doc-search-menu-icon');
      if (param) {
        searchMenuIcon[0] && searchMenuIcon[0].classList.add('hide');
        searchMenuIcon[1] && searchMenuIcon[1].classList.add('hide');
      } else {
        searchMenuIcon[0] && searchMenuIcon[0].classList.remove('hide');
        searchMenuIcon[1] && searchMenuIcon[1].classList.remove('hide');
      }
    }

    // Detect IE11 and iPad
    function detectIe11AndIpadTwoAndThree() {
      return (
        (!!window.MSInputMethodContext && !!document.documentMode) ||
        (navigator.userAgent.search('iPad') >= 0 &&
          (navigator.userAgent.match(/8.0/i) || navigator.userAgent.match(/7.0/i)))
      );
    }

    if (detectIe11AndIpadTwoAndThree()) {
      showHideSearchIcon('hide-search');
      if (document.body.classList.contains('docs-search-auth-user')) {
        document.body.classList.remove('docs-search-auth-user');
      }
    } else {
      document.body.classList.add('docs-search-auth-user');
    }

    if (bsLib.msieversion() !== false) {
      // if ie browser remove class from body.
      showHideSearchIcon('hide-search');
      if (document.body.classList.contains('docs-search-auth-user')) {
        document.body.classList.remove('docs-search-auth-user');
      }
    }
    
    window.validateSearchForm = function () {
      WebEventTracker.logEvent(EDS.webEvents, 'TriggerGlobalSearch', {
        search_text: docSearchInputBox && docSearchInputBox.value.trim()
      });
      return docSearchInputBox.value.trim() !== '';
    };

    // Dynamic Results Algolia Search Functionality
    function isNoResults(hits) {
      return hits.length === 0;
    }
    
    function getNoResultsUi() {
      return "<li class='global-search__no-results-container'>No results found</li>";
    }

    (function handleKeyboardNavigation() {
      var list = document.getElementById('global-search-autocomplete'),
        searchInput = document.getElementById('doc-search-box-input'),
        items = list.getElementsByTagName('a'),
        selectedItem = null;
    
      searchInput.addEventListener('keydown', function(event) {
        if (items.length > 0 && event.key === 'ArrowDown') {
          items[0].focus();
          selectedItem = items[0];
        }
      });
    
      list.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowDown') {
          // Move focus to the next list item
          selectedItem = getNextItem(selectedItem);
          selectedItem.focus();
          event.preventDefault();
        } else if (event.key === 'ArrowUp') {
          // Move focus to the previous list item
          selectedItem = getPreviousItem(selectedItem);
          selectedItem.focus();
          event.preventDefault();
        }
      });
    
      // Helper function to get the next list item
      function getNextItem(item) {
        if (!item) {
          return items[0];
        }
        if (item.nextElementSibling) {
          return item.nextElementSibling;
        }
        return items[0];
      }
    
      // Helper function to get the previous list item
      function getPreviousItem(item) {
        if (!item) {
          return items[0];
        }
        if (item.previousElementSibling) {
          return item.previousElementSibling;
        }
        return items[items.length - 1];
      }
    })();
    
    // recursive function to determine the parent anchor element of the suggestion list
    function findTargetAnchor(target) {
      if (target) {
        if (target.nodeName.toLowerCase() === 'a') {
          return target;
        }
        return findTargetAnchor(target.parentNode);
      }
    }

    // Handling analytics for result search list clicked on global search
    (function() {
      var autocomplete = document.getElementById('global-search-autocomplete');
      autocomplete.addEventListener('click', function(event) {
        if (window.WebEventTracker && window.EDS) {
          var targetAnchor = findTargetAnchor(event.target);
          if (targetAnchor) {
            WebEventTracker.logEvent(EDS.webEvents, 'GlobalDynamicResultClicked', {
              action: targetAnchor.classList.contains('global-search__see-all-result')
                ? 'see_all_result'
                : 'clicked_on_drop_down_result',
              clicked_on_URL: targetAnchor.getAttribute('href'),
              position: targetAnchor.getAttribute('data-index') + 1,
              search_text: targetAnchor.getAttribute('data-query'),
              content_Type: targetAnchor.classList.contains('global-search__see-all-result')
                ? ''
                : targetAnchor.getAttribute('data-category')
            });
          }
        }
      });
    })();

    function initGlobalSearch() {
      var client = algoliasearch(
          'YNHF55KPOX',
          'MDI3NWM0YzhmZWI0N2U4NzBkYTgxMjYxYWIyNzUzN2EyYWMwNTNmODgwMTVlZjM0OTZiMTM0MGYzODBjNGEyMGZpbHRlcnM9aGFzX2NvZGVfc25pcHBldCUzQWZhbHNl'
        ),
        index = client.initIndex(AlgoliaSearchConfig),
        searchInput = document.getElementById('doc-search-box-input'),
        searchFAQInput = document.querySelectorAll('.faq-support__search-input')[0],
        faqAutoComplete = document.getElementById('local-search-autocomplete'),
        autocomplete = document.getElementById('global-search-autocomplete');
    
      // global search
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          try {
            var query = searchInput.value;
            if (query.length > 3) {
              index.search(query, { hitsPerPage: 5, clickAnalytics: true }).then(function(response) {
                var hits = response.hits,
                  nbHits = response.nbHits;
      
                autocomplete.innerHTML = '';
                if (isNoResults(hits)) {
                  autocomplete.innerHTML = getNoResultsUi();
                  if (globalSearchFlag) {
                    WebEventTracker.logEvent(EDS.webEvents, 'GlobalDynamicSearchInitiated', {});
                    globalSearchFlag = false;
                  }
                } else {
                  hits.forEach(function(hit, idx) {
                    var heading = hit.headings.h1 || hit.headings.h2 || hit.headings.h3 || hit.headings.h4 || hit.headings.h5,
                      titledHeading = heading && heading.length === 0 ? hit.title : heading,
                      finalHeading = titledHeading || heading,
                      suggestionContainerSkeleton =
                        "<a href = '" +
                        hit.url +
                        "' class = 'global-search__search-suggestion' role = 'option' tabindex = '0' data-index = " +
                        idx +
                        ' data-title = ' +
                        JSON.stringify(finalHeading) +
                        ' data-query=' +
                        query +
                        ' data-category=' +
                        hit.breadcrumb[0] +
                        "><div class = 'global-search__search-suggestion-left'><div class = 'global-search__search-suggestion-title'>" +
                        finalHeading +
                        "</div><div class = 'global-search__search-suggestion-description'>" +
                        hit.description +
                        "</div></div><div class = 'global-search__search-suggestion-category' data-category=" +
                        hit.breadcrumb[0] +
                        '>' +
                        hit.breadcrumb[0] +
                        '</div></a>';
      
                    autocomplete.innerHTML += suggestionContainerSkeleton;
                    if (globalSearchFlag) {
                      WebEventTracker.logEvent(EDS.webEvents, 'GlobalDynamicSearchInitiated', {});
                      globalSearchFlag = false;
                    }
                  });
                }
      
                if (nbHits > 5) {
                  var seeAllResults =
                    "<a href = '/search?query=" +
                    query +
                    "&type=all' class = 'global-search__search-suggestion global-search__see-all-result' role = 'option' data-title = 'See All' tabindex='0' data-index= " +
                    hits.length +
                    ' data-query=' +
                    query +
                    '>See all (' +
                    nbHits +
                    ') results</li>';
                  autocomplete.innerHTML += seeAllResults;
                }
              });
            }
          } catch (e) {}
        });
      }
      
      // local faq search
      if (searchFAQInput) {
        searchFAQInput.addEventListener('input', function() {
          try {
            var query = searchFAQInput.value;
            if (query.length > 3) {
              index.search(query, {
                  hitsPerPage: 5,
                  clickAnalytics: true,
                  filters: '(type:documentation OR type:support)',
                  optionalFilters: [
                    'type:support'
                  ]
                }).then(function(response) {
                var hits = response.hits,
                  nbHits = response.nbHits;
    
                faqAutoComplete.innerHTML = '';
                if (isNoResults(hits)) {
                  faqAutoComplete.innerHTML = getNoResultsUi();
                  if (localSearchFlag) {
                    WebEventTracker.logEvent(EDS.webEvents, 'FaqSupportDynamicSearchInitiated', {});
                    localSearchFlag = false;
                  }
                } else {
                  hits.forEach(function(hit, idx) {
                    var heading = hit.headings.h1 || hit.headings.h2 || hit.headings.h3 || hit.headings.h4 || hit.headings.h5,
                      titledHeading = heading && heading.length === 0 ? hit.title : heading,
                      finalHeading = titledHeading || heading,
                      suggestionContainerSkeleton =
                        "<a href = '" +
                        hit.url +
                        "' class = 'global-search__search-suggestion' role = 'option' tabindex = '0' data-index = " +
                        idx +
                        ' data-title = ' +
                        JSON.stringify(finalHeading) +
                        ' data-query=' +
                        query +
                        ' data-category=' +
                        hit.breadcrumb[0] +
                        "><div class = 'global-search__search-suggestion-left'><div class = 'global-search__search-suggestion-title'>" +
                        finalHeading +
                        "</div><div class = 'global-search__search-suggestion-description'>" +
                        hit.description +
                        "</div></div><div class = 'global-search__search-suggestion-category' data-category=" +
                        hit.breadcrumb[0] +
                        '>' +
                        hit.breadcrumb[0] +
                        '</div></a>';
      
                    faqAutoComplete.innerHTML += suggestionContainerSkeleton;
                    if (localSearchFlag) {
                      WebEventTracker.logEvent(EDS.webEvents, 'FaqSupportDynamicSearchInitiated', {});
                      localSearchFlag = false;
                    }
                  });
                }
      
                if (nbHits > 5) {
                  var seeAllResults =
                    "<a href = '/search?query=" +
                    query +
                    "&type=all' class = 'global-search__search-suggestion global-search__see-all-result' role = 'option' data-title = 'See All' tabindex='0' data-index= " +
                    hits.length +
                    ' data-query=' +
                    query +
                    '>See all (' +
                    nbHits +
                    ') results</li>';
                  faqAutoComplete.innerHTML += seeAllResults;
                }
              });
            }
          } catch (e) {}
        });

        // On Esc reset the flag for dynamic event
        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' || event.keyCode === 27) {
            localSearchFlag = true;
          }
        });
      }
      
      // On Doc click empty the search results
      document.addEventListener('click', function(event) {
        if (autocomplete && !autocomplete.contains(event.target)) {
          autocomplete.innerHTML = '';
          globalSearchFlag = true;
        }
        if (faqAutoComplete && !faqAutoComplete.contains(event.target)) {
          faqAutoComplete.innerHTML = '';
          localSearchFlag = true;
        }
      });
    }

    window.onresize = function() {
      if (window.innerWidth > 767) {
        initGlobalSearch();
      }
    };

    if (window.innerWidth > 767) {
      initGlobalSearch();
    }
  }
})();
